import { useCallback, useEffect, useState } from 'react'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** API */
import TemplateDoctorFeeApi from 'api/setting/doctor-fee-managements/template-doctor-fee.api'

import { isCopy, isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Fade, Grid, InputAdornment, Tooltip, Typography } from '@mui/material'
import ClinicApi from 'api/master/clinic.api'
import { swalCustom } from 'component/Alert/Swal'
import HeaderCard from 'component/CardCustom/HeaderCard'
import HelperText from 'component/Input/HelperText'
import Loading from 'component/Loading'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import _ from 'lodash'
import CheckboxButton from 'new-components/buttons/checkbox-button'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import SelectCheckBoxInput from 'new-components/inputs/select_checkbox_input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import ReactDOMServer from 'react-dom/server'
import { useHistory } from 'react-router-dom'
import { routeName } from 'routes/routes-name'
import { getBranch } from 'utils/app.utils'
import './style'

type Branch = {
  branchId: number
  branchName: string
}

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView(),
  isCopy: isCopy(),
}

const initStateErrorMessage = {
  TEMPLATE_DOCTOR_FEE_NAME: ``,
  BRANCH_ID: ``,
  BRANCH_MAIN_ID: ``,
  CHECK_BRANCHS: ``
}

export default function TemplateDoctorFee() {
  const { t } = useTranslation()
  const history = useHistory()
  const [templateDoctorFees, setTemplateDoctorFee] = useState([])
  const [loading, setLoading] = useState(false)
  const [objCopy, setObjCopy] = useState({ templateDoctorFeeId: 0, templateDoctorFeeName: '', })
  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  const [selectBranch, setSelectBranch] = useState<any[]>([])
  const [branches, setBranches] = useState<any[]>([])
  const [checkLink, setCheckLink] = useState<'1' | '0'>('0')

  const [selectBranchOption, setSelectBranchOption] = useState<any>([])
  const [branchMainId, setBranchMainId] = useState<any>(null)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')

  const [isCopy, setIsCopy] = useState(false)

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [seleteBranchId, setSeleteBranchId] = useState<number>(0)
  const [connect, setConnect] = useState(false)
  const [name, setName] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [status, setStatus] = useState('ALL')
  const [checkBranchs, setCheckBranchs] = useState(false)
  const [disabledSubmit, setDisabledSubmit] = useState(false)

  useEffect(() => {
    if (selectBranch?.length >= 1) {
      const newData: any = []
      selectBranch.map((item) => {
        const data = branches.find((info) => info.id === item)

        newData.push(data)
        setSelectBranchOption(newData.map((item: any) => ({ value: item.id, name: item.name })))
      })
    } else {
      setCheckLink('0')
      setSelectBranchOption([])
    }
  }, [selectBranch])

  const loadData = async () => {
    try {
      const resp = await TemplateDoctorFeeApi.findAll({
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setTemplateDoctorFee(resp.data)
      } else {
        setTemplateDoctorFee([])
      }
    } catch (error) {
      notiError('เกิดข้อผิดพลาด')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])


  const loadBranche = useCallback(() => {
    ClinicApi.findAllBranches().then(({ data }) => {
      setBranches(data.map((d: any) => ({ id: d.branchId, name: d.branchName, disabled: seleteBranchId === d.branchId })))
      // setSelectBranch(['ALL', ...data.map((d: any) => d.branchId)])
      setSelectBranch([])
    })

  }, [])

  useEffect(() => {
    loadBranche()
  }, [loadBranche])

  const onCreate = () => {
    history.push(routeName.templateDoctorFee + '/create')
  }

  const onSubmit = () => {
    setDisabledSubmit(true)


    const branch = [..._.map(_.filter(selectBranch, (branchId: any) => { if (branchId !== "ALL") return branchId }), (branchId: any) => { return { branchId: branchId } })]
    if (!objCopy.templateDoctorFeeName || !branch.length || (checkLink === '1' && !branchMainId) || checkLink === '0') {
      setCheckBranchs(true)
      setLoading(false)
      setDisabledSubmit(false)
      return setErrorMessage({
        TEMPLATE_DOCTOR_FEE_NAME: !objCopy.templateDoctorFeeName ? t('TEMPLATE_DOCTOR_FEE.MESSAGE.ERROR.EMPTY_DF_NAME') : '',
        BRANCH_ID: !branch.length ? t('TEMPLATE_DOCTOR_FEE.MESSAGE.ERROR.BRANCH_ID') : '',
        BRANCH_MAIN_ID: (checkLink === '1' && !branchMainId) ? t('TEMPLATE_DOCTOR_FEE.MESSAGE.ERROR.BRANCH_MAIN_ID') : '',
        CHECK_BRANCHS: checkLink === '0' ? 'กรุณาเลือกเชื่อมต่อหลายสาขา' : ''
      })
    }

    const objData = {
      templateDoctorFeeName: objCopy.templateDoctorFeeName,
      branch: branch,
      connect: checkLink,
      branchMainId: branchMainId
    }
    setLoading(true)
    TemplateDoctorFeeApi.copy(objCopy.templateDoctorFeeId, objData)
      .then((res) => {
        notiSuccess(t('TEMPLATE_DOCTOR_FEE.MESSAGE.SUCCESS.CREATE'), '', null, null)
        loadData()
        setObjCopy({ templateDoctorFeeId: 0, templateDoctorFeeName: '', })
        setSelectBranch([])
        setCheckLink('0')
        setIsCopy(false)
        setLoading(false)
        setDisabledSubmit(false)
      })
      .catch((e) => {
        setLoading(false)
        setDisabledSubmit(false)
        if (e.response.data.message === 'IS_MAIN_TEMPLATE_ALREADY_EXISTS') return notiError(t('TEMPLATE_DOCTOR_FEE.MESSAGE.ERROR.IS_MAIN_TEMPLATE_ALREADY_USE'), '', null, null, '')
        else if (e.response.data.message === 'IS_DUPLICATE_TEMPLATE_DOCTOR_FEE_NAME') {
          const dataError = e?.response?.data?.error?.split(',').map((item: any) => parseInt(item.trim()));
          const newHtml = (
            <div>
              <div>{t('TEMPLATE_DOCTOR_FEE.MESSAGE.ERROR.NAME_IS_DUP_TITLE')}{`"${objCopy?.templateDoctorFeeName}"`}</div>
              <div>{t('TEMPLATE_DOCTOR_FEE.MESSAGE.ERROR.NAME_IS_DUP_SUBTITLE')}</div>
              <div style={{ textAlign: 'left', marginTop: '6px' }}>
                <div style={{ fontWeight: 500, color: 'black' }}>{t('TEMPLATE_DOCTOR_FEE.MESSAGE.ERROR.NAME_IS_DUP_HEADER')}</div>
                <ul>
                  {dataError.map((item: any, index: number) => {
                    return <li key={index}>{branches.find((info) => info.id === item)?.name || ''}</li>
                  })}
                </ul>
              </div>
            </div>
          )

          const htmlString = ReactDOMServer.renderToString(newHtml);
          const parser = new DOMParser();
          const htmlElement = parser.parseFromString(htmlString, 'text/html').body.firstChild;

          swalCustom(
            t('TEMPLATE_DOCTOR_FEE.MESSAGE.ERROR.IS_DUP_NAME_TEMPLATE_DF'),
            htmlElement,
            (res: any) => null,
            'warning',
            {
              confirmButton: {
                showConfirmButton: false
              },
              cancelButton: {
                cancelButtonText: t('BUTTON.ENTER')
              }
            }
          )
          //  return notiError(t('TEMPLATE_DOCTOR_FEE.MESSAGE.ERROR.IS_DUPLICATE_TEMPLATE_DOCTOR_FEE_NAME'), '', null, null, '')
          return
        }
        else return notiError(e.response.data.message, '', null, null, '')
      })
  }

  const onActive = () => {
    if (id) {
      TemplateDoctorFeeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TEMPLATE_DOCTOR_FEE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TEMPLATE_DOCTOR_FEE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onDelete = () => {
    if (id) {
      TemplateDoctorFeeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TEMPLATE_DOCTOR_FEE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TEMPLATE_DOCTOR_FEE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { templateDoctorFeeId } = data
    history.push(`${routeName.templateDoctorFee}/${templateDoctorFeeId}`)
  }

  const onCopy = async (data: any) => {
    const { templateDoctorFeeId, templateDoctorFeeName, amount, labDoctorAmount, isMain, branchId } = data
    setObjCopy({ templateDoctorFeeId: templateDoctorFeeId, templateDoctorFeeName: `${templateDoctorFeeName}(Copy)` })
    setIsCopy(true)
    setSeleteBranchId(branchId)
  }

  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const headCells = [
    { id: 'no', disablePadding: false, label: '#', width: '6%' },
    { id: 'templateDoctorFeeName', disablePadding: false, label: t(`DOCTOR_FEE.FORM.DF_LAB_NAME`), width: '36%' },
    { id: 'amount', disablePadding: false, label: t(`สาขาที่สร้าง`), width: '19%' },
    { id: 'amount', disablePadding: false, label: t(`สาขาที่ใช้งาน`), width: '19%' },
    { id: 'status', disablePadding: false, label: t('TABLE.CELL.STATUS'), width: '14%' },
    { id: 'updatedBy', disablePadding: false, label: t('TABLE.CELL.UPDATED_BY'), width: '15%' },
    { id: 'action', disablePadding: false, label: 'Action', width: '10%' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { templateDoctorFeeId, templateDoctorFeeName, amount, status: tempDfStatus, updatedAt, updatedBy, branchConnect, connectTemplateDoctorFeeId
    } = objData
    const branchNames = branchConnect.map((branches: any) => { return branches.brnachName })
    const statusBtnActive = tempDfStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = tempDfStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: templateDoctorFeeId,
      id: templateDoctorFeeId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: templateDoctorFeeName },
        {
          option: 'COMPONENT', align: 'left',
          component: <Tooltip
            title={objData?.branchMain}
            TransitionComponent={Fade}
            placement="bottom" >
            <div>{objData?.branchMain}</div>
          </Tooltip>
        },
        {
          option: 'COMPONENT', align: 'left',
          component: <Tooltip
            title={branchNames.length ? branchNames.join(', ') : ''}
            TransitionComponent={Fade}
            placement="bottom" >
            <div>{branchNames.length ? branchNames[0] : ''}{branchNames?.length > 1 && '...'}</div>
          </Tooltip>
        },
        { option: 'STATUS', align: 'center', label: tempDfStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive || connectTemplateDoctorFeeId },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive || connectTemplateDoctorFeeId },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'COPY', label: t(`BUTTON.COPY`), disabled: permissions.isCopy.disabled },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled || getBranch() !== objData.branchId }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        oncopy={() => onCopy(objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setConnect(obj.connect === "1")
    setIsOpenAlertModal(true)
    setName(obj.templateDoctorFeeName)
  }

  return (
    <Box>
      <Loading show={loading} />
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`TEMPLATE_DOCTOR_FEE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`TEMPLATE_DOCTOR_FEE.ALERT.${statusAlertModal === 'DELETE' ? `${'CONFIRM_DELETE_'}` : 'CONFIRM_STATUS'}`, { templateDoctorFeeName: name, status: t(`TEMPLATE_DOCTOR_FEE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      >{(statusAlertModal === 'DELETE' && connect) && <Box display="flex" justifyContent="center" flexDirection='column' gap="16px" textAlign="center">
        <Typography fontSize="12px" fontWeight={400} style={{ whiteSpace: 'pre-line' }} color={'#FB5252'}>{t(`TEMPLATE_DOCTOR_FEE.ALERT.CONFIRM_DELETE_CONNECT`, { templateDoctorFeeName: name, status: t(`TEMPLATE_DOCTOR_FEE.ALERT.${statusAlertModal}`) })}</Typography>
      </Box>}
      </AlertModal>
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <PageModal
        title={t('TEMPLATE_DOCTOR_FEE.TITLE.COPY_TEMPLATE_DEFAULT')}
        size='XS'
        isOpen={isCopy}
        handleClose={() => {
          setObjCopy({ templateDoctorFeeId: 0, templateDoctorFeeName: '' })
          setCheckLink('0')
          setSelectBranch([])
          clearErrorMessage()
          setIsCopy(false)
        }}
        onCancel={{
          onClick: () => {
            setObjCopy({ templateDoctorFeeId: 0, templateDoctorFeeName: '' })
            setCheckLink('0')
            setSelectBranch([])
            clearErrorMessage()
            setIsCopy(false)
          }
        }}
        onSubmit={{ onClick: onSubmit, disabled: disabledSubmit }}
      >
        <Box display="flex" flexDirection="column" gap="16px">
          <TextInput
            onChange={(event) => {
              setObjCopy({ ...objCopy, templateDoctorFeeName: event.target.value })
              clearErrorMessage()
            }}
            value={objCopy.templateDoctorFeeName}
            label={t('TEMPLATE_DOCTOR_FEE.FORM.TEMPLATE_NAME')}
            helperText={errorMessage.TEMPLATE_DOCTOR_FEE_NAME}
            required
          />
          <SelectCheckBoxInput
            required
            label={t('TEMPLATE_DOCTOR_FEE.FORM.BRANCH')}
            onChange={(e) => {
              setSelectBranch(e)
              setBranchMainId(0)
            }}
            options={branches}
            selected={selectBranch}
            helperText={errorMessage.BRANCH_ID}
          />
          <Box>
            <CheckboxButton
              disabled={selectBranch?.length < 1}
              label={t('TEMPLATE_DOCTOR_FEE.FORM.LINK_MANY_BRANCH')}
              checked={checkLink === '1' ? true : false}
              onChange={() => {
                setCheckBranchs(false)
                setBranchMainId(0)
                setCheckLink(checkLink === '1' ? '0' : '1')
              }}
              req={true}
            />
            {checkLink === '0' && checkBranchs && <HelperText label={errorMessage.CHECK_BRANCHS} />}
          </Box>
          {checkLink === '1' &&
            <SelectInput
              label={t('TEMPLATE_DOCTOR_FEE.FORM.BRANCH_MAIN')}
              onChange={(e) => {
                clearErrorMessage()
                setBranchMainId(e.target.value)
              }}
              options={selectBranchOption}
              required
              value={branchMainId}
              helperText={errorMessage.BRANCH_MAIN_ID}
            />
          }
        </Box>
      </PageModal>
      <HeaderCard text={t('TEMPLATE_DOCTOR_FEE.TITLE.MANAGE_DEFAULT')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('TEMPLATE_DOCTOR_FEE.TITLE.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') },
              ]}
              value={status}
              label={t('STATUS.LABEL')}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />
              <MainButton title={t('TEMPLATE_DOCTOR_FEE.TITLE.ADD_TEMPLATE_DEFAULT')} disabled={permissions.isCreate.disabled} type='primary' variant='contained' onClick={() => onCreate()} startIcon={<AddCircleIcon />} />
            </Box>
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={templateDoctorFees.map((val, i) => {
              return renderData(val, i)
            })}
            tableFixedWidth
            tableMinWidth={1000}
          />
        </Box>
      </Box>
    </Box>
  )
}
